<sdc-bo-dialog
  headerTitle="Edit Discount Code"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'discount-edit-modal'">
  <div class="content-wrapper">
    <div>
      <div class="input-line">
        <div>
          <span><b>Code</b> <span class="mandatory-asterisk">*</span></span>
        </div>
        <div>
          <input
            [attr.data-cy]="'discount-edit-modal-code-input'"
            type="text"
            [(ngModel)]="item.code"
            [class.invalid-input]="hashValidator.code" />
          @if (hashValidator.code) {
            <span class="text-[80%] error-color"
              >Code is required (3-32 chars, A-Z 0-9 _ -)</span
            >
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span
            ><b>Description</b> <span class="mandatory-asterisk">*</span></span
          >
        </div>
        <div>
          <textarea
            [attr.data-cy]="'discount-edit-modal-description-input'"
            [(ngModel)]="item.description"
            [class.invalid-input]="hashValidator.description"></textarea>
          @if (hashValidator.description) {
            <span class="text-[80%] error-color">Description is required</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span
            ><b>Discount %</b> <span class="mandatory-asterisk">*</span></span
          >
        </div>
        <div>
          <input
            [attr.data-cy]="'discount-edit-modal-percentage-input'"
            type="number"
            [(ngModel)]="item.discountPercentage"
            min="1"
            max="99"
            [class.invalid-input]="hashValidator.discountPercentage" />
          @if (hashValidator.discountPercentage) {
            <span class="text-[80%] error-color">Must be between 1 and 99</span>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Enabled</b></span>
        </div>
        <div>
          <select [(ngModel)]="item.enabled">
            <option [ngValue]="true">On</option>
            <option [ngValue]="false">Off</option>
          </select>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Max Uses</b></span>
        </div>
        <div>
          <input
            [attr.data-cy]="'discount-edit-modal-max-uses-input'"
            type="number"
            [(ngModel)]="item.maxUses"
            placeholder="Unlimited"
            min="1" />
          <span class="text-[80%] text-[#6c757d]"
            >Leave empty for unlimited</span
          >
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Min Balance</b></span>
        </div>
        <div>
          <input
            [attr.data-cy]="'discount-edit-modal-min-balance-input'"
            type="number"
            [(ngModel)]="item.minBalance"
            placeholder="No minimum"
            min="0" />
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Max Balance</b></span>
        </div>
        <div>
          <input
            [attr.data-cy]="'discount-edit-modal-max-balance-input'"
            type="number"
            [(ngModel)]="item.maxBalance"
            placeholder="No maximum"
            min="0" />
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Valid From</b></span>
        </div>
        <div class="datetime-input-wrapper">
          <input
            [attr.data-cy]="'discount-edit-modal-valid-from-input'"
            type="datetime-local"
            [(ngModel)]="item.validFrom" />
          @if (item.validFrom) {
            <button
              type="button"
              class="datetime-clear-btn"
              (click)="item.validFrom = null">
              <ng-icon name="lucideX" size="1rem"></ng-icon>
            </button>
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Valid Until</b></span>
        </div>
        <div class="datetime-input-wrapper">
          <input
            [attr.data-cy]="'discount-edit-modal-valid-until-input'"
            type="datetime-local"
            [(ngModel)]="item.validUntil" />
          @if (item.validUntil) {
            <button
              type="button"
              class="datetime-clear-btn"
              (click)="item.validUntil = null">
              <ng-icon name="lucideX" size="1rem"></ng-icon>
            </button>
          }
        </div>
      </div>
    </div>
    <div class="ms-6">
      <div class="toggle-group mt-0 mb-4 px-4 py-2">
        <div class="toggle-wrapper">
          <input
            id="select-all-events-discount-edit"
            type="checkbox"
            [(ngModel)]="isAllEventsSelected"
            (change)="onSelectAllEventsChange($event)" />
          <label for="select-all-events-discount-edit">
            Select all events
          </label>
        </div>
      </div>
      <gs-event-selector
        [initialSelected]="item.events"
        [ngModel]="selectedEventIds"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onEventSelectionChange($event)"
        (selectionMeta)="onEventSelectionMeta($event)"></gs-event-selector>
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button
      [attr.data-cy]="'discount-edit-modal-cancel-button'"
      variant="secondary"
      (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button
      [attr.data-cy]="'discount-edit-modal-confirm-button'"
      variant="primary"
      (onClick)="onConfirm()">
      Save Changes
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
